const exactTranslations = {
  'Accueil': 'Home',
  'Prendre un rendez-vous': 'Book an appointment',
  'Prendre rendez-vous': 'Book now',
  'Sélectionnez un service': 'Select a service',
  'Voir les disponibilités': 'View availability',
  'Choisir une spécialité': 'Choose a specialty',
  'Veuillez choisir une spécialité.': 'Please choose a specialty.',
  'Aucun professionnel trouvé pour cette spécialité.': 'No professionals were found for this specialty.',
  'Trouver un professionnel de santé en fonction de vos besoins.': 'Find a healthcare professional based on your needs.',
  'Trouvez un professionnel de santé en fonction de vos besoins.': 'Find a healthcare professional based on your needs.',
  'Soins à domicile': 'Home care',
  'Santé mentale': 'Mental health',
  'Bien-être': 'Wellness',
  'Analyses de sang': 'Blood tests',
  'Livraison de médicaments': 'Medication delivery',
  'Service À Venir': 'Service coming soon',
  'Ce service sera bientôt disponible.': 'This service will be available soon.',
  'Rendez-vous confirmé !': 'Appointment confirmed!',
  'Merci pour votre paiement. Voici les détails :': 'Thank you for your payment. Here are the details:',
  'Retour à l’accueil': 'Back to home',
  'Voir mes rendez-vous': 'View my appointments',
  'Aucune donnée de rendez-vous': 'No appointment data found',
  'Réserver un créneau': 'Reserve a time slot',
  'Date du rendez-vous': 'Appointment date',
  'Heure du rendez-vous': 'Appointment time',
  'Professionnel': 'Professional',
  'Service': 'Service',
  'Nom': 'Last name',
  'Prénom': 'First name',
  'Téléphone': 'Phone',
  'Adresse': 'Address',
  'Code postal': 'Postal code',
  'Date de naissance': 'Date of birth',
  'Notes spéciales': 'Special notes',
  'Créer un compte': 'Create an account',
  "Continuer en tant qu'invité": 'Continue as guest',
  'Récapitulatif': 'Summary',
  'Payer et confirmer': 'Pay and confirm',
  'Modifier les informations': 'Edit information',
  'Non fourni': 'Not provided',
  'Non fournie': 'Not provided',
  'Non spécifiée': 'Not specified',
  'Aucune': 'None',
  'En personne': 'In person',
  'En ligne': 'Online',
  'Confirmation du rendez-vous': 'Appointment confirmation',
  'Date': 'Date',
  'Heure': 'Time',
  'Mode': 'Mode',
  'Informations du patient': 'Patient information',
  'Montant à payer': 'Amount due',
  'Votre adresse email n\'est pas encore vérifiée.': 'Your email address has not been verified yet.',
  'Merci de vérifier votre boîte mail et cliquer sur le lien de confirmation.': 'Please check your inbox and click the confirmation link.',
  'Email vérifié avec succès !': 'Email verified successfully!',
  'Procéder au paiement': 'Proceed to payment',
  'Chargement...': 'Loading...',
  'Chargement du profil...': 'Loading profile...',
  'Chargement des notes...': 'Loading notes...',
  'Chargement des factures...': 'Loading invoices...',
  'Chargement du dossier santé...': 'Loading health record...',
  'Aucune note médicale trouvée.': 'No medical note found.',
  'Mes factures': 'My invoices',
  'Payée': 'Paid',
  'En attente': 'Pending',
  'Liste des prestataires': 'Provider list',
  'Espace Prestataire': 'Provider Portal',
  'Espace Client': 'Client Portal',
  'Déconnexion': 'Log out',
  'Rejoindre': 'Join',
  'Informations De Contact': 'Contact Information',
  'Horaires': 'Hours',
  'Service Client': 'Customer Service',
  'Prise De RDV': 'Booking',
  'Réseaux Sociaux': 'Social Media',
  'Liens utiles': 'Useful Links',
  'Partenariat': 'Partnerships',
  'Devenir prestataire': 'Become a provider',
  'Tous droits réservés': 'All rights reserved',
  'Mon calendrier': 'My calendar',
  'Consultez vos disponibilités, rendez-vous et propositions en un seul endroit.': 'Review your availability, appointments, and proposals in one place.',
  'Fréquence': 'Frequency',
  'Hebdomadaire': 'Weekly',
  'Mensuelle': 'Monthly',
  'Récurrence': 'Recurring schedule',
  'Ou nombre d\'occurrences :': 'Or number of occurrences:',
  'Choisir les détails': 'Choose details',
  'OK': 'OK',
  'Lundi': 'Monday',
  'Mardi': 'Tuesday',
  'Mercredi': 'Wednesday',
  'Jeudi': 'Thursday',
  'Vendredi': 'Friday',
  'Samedi': 'Saturday',
  'Dimanche': 'Sunday',
  'Lun': 'Mon',
  'Mar': 'Tue',
  'Mer': 'Wed',
  'Jeu': 'Thu',
  'Ven': 'Fri',
  'Sam': 'Sat',
  'Dim': 'Sun',
  'janvier': 'January',
  'février': 'February',
  'mars': 'March',
  'avril': 'April',
  'mai': 'May',
  'juin': 'June',
  'juillet': 'July',
  'août': 'August',
  'septembre': 'September',
  'octobre': 'October',
  'novembre': 'November',
  'décembre': 'December',
};

const partialTranslations = [
  ['❌ Paramètres manquants. Veuillez revenir à l’étape précédente.', '❌ Missing parameters. Please return to the previous step.'],
  ['Un lien de confirmation vous a été envoyé à', 'A confirmation link has been sent to'],
  ['Veuillez sélectionner un service avant de continuer.', 'Please select a service before continuing.'],
  ['Le code postal n’est pas valide. Exemple valide : H1A 2B3', 'The postal code is not valid. Valid example: H1A 2B3'],
  ['Merci de remplir le nom, prénom et email.', 'Please fill in your first name, last name, and email.'],
  ['Erreur lors de la réservation. Vérifie les champs ou réessaie plus tard.', 'There was an error while booking. Please check the form or try again later.'],
  ['Erreur chargement spécialités', 'Error loading specialties'],
  ['Erreur récupération professionnels', 'Error loading professionals'],
  ['Erreur chargement des factures', 'Error loading invoices'],
  ['Erreur chargement du dossier santé', 'Error loading health record'],
  ['Erreur de chargement du profil.', 'Error loading profile.'],
  ['Aucune note médicale trouvée.', 'No medical note found.'],
  ['Connexion en cours...', 'Signing you in...'],
  ['Chargement du résumé…', 'Loading summary...'],
  ['Rafraîchir le résumé', 'Refresh summary'],
  ['Aucun résumé encore disponible. La transcription s’arrête automatiquement à la fin de séance.', 'No summary is available yet. Transcription stops automatically at the end of the session.'],
  ['Récupération…', 'Fetching...'],
  ['Résumé', 'Summary'],
  ['Professionnels', 'Professionals'],
  ['prestataires', 'providers'],
  ['Prestataire', 'Provider'],
  ['prestataire', 'provider'],
  ['Client', 'Client'],
  ['clients', 'clients'],
  ['Rendez-vous', 'Appointments'],
  ['rendez-vous', 'appointment'],
  ['spécialité', 'specialty'],
  ['Spécialité', 'Specialty'],
  ['Zone couverte', 'Coverage area'],
  ['Voir le profil', 'View profile'],
  ['Chargement', 'Loading'],
  ['Erreur', 'Error'],
  ['Aucun', 'No'],
  ['Aucune', 'No'],
  ['Veuillez', 'Please'],
  ['Retour', 'Back'],
  ['Retour à la liste des clients', 'Back to client list'],
  ['Langues parlées', 'Languages spoken'],
  ['Non renseigné', 'Not provided'],
  ['Non renseignée', 'Not provided'],
  ['Zone géographique', 'Geographic area'],
  ['Notes au dossier', 'File notes'],
  ['Note liée à un rendez-vous', 'Note linked to an appointment'],
  ['Soins de santé personnalisés', 'Personalized healthcare'],
  ['Consultation À Domicile', 'Home Visit'],
  ['Consultation En Ligne', 'Online Consultation'],
  ['Dossier Médical Numérisé', 'Digital Medical Record'],
  ['Rendez-Vous En Ligne', 'Online Appointments'],
];

const bilingualValueMap = {
  'aidant standard': 'standard caregiver',
  'aidant soins lourds': 'heavy-care caregiver',
  'infirmière': 'nurse',
  'infirmier': 'nurse',
  'infirmière auxiliaire': 'auxiliary nurse',
  'infirmier auxiliaire': 'auxiliary nurse',
  'autre prestataire': 'other provider',
  'plan de soins intégré': 'integrated care plan',
  'frais administratifs': 'administrative fee',
  'annulé': 'cancelled',
  'confirmé': 'confirmed',
  'en attente': 'pending',
  'virtuel': 'virtual',
  'à domicile': 'at home',
  'soins à domicile': 'home care',
  'santé mentale': 'mental health',
  'bien-être': 'wellness',
  'analyses de sang': 'blood tests',
  'livraison de médicaments': 'medication delivery',
  'français': 'French',
  'anglais': 'English',
  'espagnol': 'Spanish',
  'hindi': 'Hindi',
  'créole': 'Creole',
  'filipino': 'Filipino',
  'italien': 'Italian',
  'russe': 'Russian',
  'arabe': 'Arabic',
  'roumain': 'Romanian',
  'débutant': 'Beginner',
  'intermédiaire': 'Intermediate',
  'avancé': 'Advanced',
};

function replaceExact(text) {
  const trimmed = text.trim();
  if (!trimmed) return text;

  const translated = exactTranslations[trimmed];
  if (!translated) return text;

  return text.replace(trimmed, translated);
}

function replacePartial(text) {
  let translated = text;
  partialTranslations.forEach(([from, to]) => {
    translated = translated.split(from).join(to);
  });
  return translated;
}

export function translateLegacyContent(value, language = 'fr') {
  if (language !== 'en' || value == null) return value;

  if (Array.isArray(value)) {
    return value.map((item) => translateLegacyContent(item, language));
  }

  if (typeof value !== 'string') return value;

  const exact = replaceExact(value);
  const partial = replacePartial(exact);
  const normalized = partial.trim().toLowerCase();

  if (bilingualValueMap[normalized]) {
    return partial.replace(partial.trim(), bilingualValueMap[normalized]);
  }

  return partial;
}

export function translateLegacyValue(value, language = 'fr') {
  if (language !== 'en' || value == null) return value;

  const normalized = String(value).trim().toLowerCase();
  return bilingualValueMap[normalized] || translateLegacyContent(String(value), language);
}
